<template>
  <div class="mb-0" v-resize="onResize" ref="mainDiv">
    <div v-if="isReadonly" class="overlay" @mousedown.prevent @touchstart.prevent></div>
    <div v-if="isReadonly" class="hamburger-overlay" @mousedown.prevent @touchstart.prevent></div>
    <v-card class="my-0 mx-2" flat>
      <v-card-title class="pa-0">
        <v-btn color="primary" class="white--text mx-0 my-2" @click="navigateBack()">
          <v-icon large>mdi-chevron-left</v-icon>
        </v-btn>
        <div class="flex-grow-1"></div>
        <div :class="breakpoint === 'xs' ? 'text-h6' : 'text-h5'">{{ groupName }}</div>
        <div class="flex-grow-1"></div>
        <v-spacer />
      </v-card-title>
      <v-card-text class="px-1">
        <v-row>
          <v-col cols="5">
            <v-text-field :color="(this.badge == FLOOR_EGG || this.badge == NEST_EGG) && !errorBadgeMsg ? 'orange' : ''"
              :hint="this.badge == FLOOR_EGG ? 'Floor Egg' : this.badge == NEST_EGG ? 'Nest Egg' : ''"
              :class="(this.badge == FLOOR_EGG || this.badge == NEST_EGG) && !errorBadgeMsg ? 'badge-floor-egg-style' : ''"
              v-model="badge" ref="badgeRef" label="Badge" clearable :disabled="!config.line"
              :inputmode="config.keyboardDisabled ? 'none' : 'text'" @keydown.enter="valueEntered()"
              @change="badgeChanged(); validateInputFields()" @focus="onbadgeFocus($event)"
              :error-messages="errorBadgeMsg" />

            <v-text-field v-if="config.keyboardDisabled" style="padding: 0 0 0 0; margin-top: 16px" v-model="grade"
              ref="gradeRef" :label="`Grade ${badgeGradeType}`" clearable :disabled="!config.line" inputmode="none"
              @focus="onGradeFocus($event)" @keydown.enter="valueEntered()" :error-messages="errorGradeMsg" />
            <v-combobox v-else style="padding: 0 0 8px 0; margin-top: 18px" v-model="grade" ref="gradeRef" dense
              :items="gradeDescs" item-text="code" :label="`Grade ${badgeGradeType}`" :disabled="!config.line"
              @focus="showGradeMenu(true)" @blur="showGradeMenu(false)" @change="valueEntered()"
              :error-messages="errorGradeMsg" />
            <v-text-field v-if="!config.confirmBadgeDisabled" class="pt-0 mt-3" v-model="confirmBadge"
              ref="confirmBadgeRef" label="Confirm Badge" clearable :disabled="!config.line"
              :inputmode="config.keyboardDisabled ? 'none' : 'text'" @keydown.enter="valueEntered()"
              @focus="onbadgeFocus($event)" @change="validateInputFields()" :error-messages="errorConfirmBadgeMsg" />
            <v-btn
              width="100%"
              :class="breakpoint === 'xs' ? 'white--text mt-1 mb-1' : 'white--text'" color="primary"
              @click="showSummary()">
              <v-icon>mdi-file-document-outline</v-icon>SUMMARY
            </v-btn>

          </v-col>
          <v-col cols="7" class="pr-0">
            <div class="d-flex">
              <!-- add button -->
              <!-- <v-btn fab :small="breakpoint === 'xs'"
                :class="breakpoint === 'xs' ? 'white--text mt-3 mb-1' : 'white--text'" color="primary"
                :disabled="addEggDisabled" @click="valueEntered()">
                <v-icon>mdi-plus</v-icon>
              </v-btn> -->

              <!-- clear button -->
              <v-btn :class="breakpoint === 'xs' ? 'white--text mt-3 mb-1 ml-2' : 'white--text ml-2'" fab
                :small="breakpoint === 'xs'" color="primary" @click="resetInputFields();">
                <v-icon>mdi-close</v-icon>
              </v-btn>

              <!-- floor egg button -->
              <v-btn :class="breakpoint === 'xs' ? 'white--text mt-3 mb-1 ml-2' : 'white--text ml-2'" fab
                :small="breakpoint === 'xs'" color="primary" :disabled="!config.checkPedigreeDisabled"
                @click="showUnknownEggDialog = true">
                <v-icon>mdi-egg-easter</v-icon>
              </v-btn>

              <!-- settings button -->
              <v-btn :class="breakpoint === 'xs' ? 'white--text mt-3 mb-1 ml-2' : 'white--text ml-2'" fab
                :small="breakpoint === 'xs'" color="primary" @click="showConfigDialog = true">
                <v-icon>mdi-cog</v-icon>
              </v-btn>
              <v-spacer />

              <!-- Printer Status -->
              <div v-if="printerConnected" class="ml-2 text-right">
                <v-chip small>
                  <v-icon :color=batteryLevelColor>
                    {{ batteryLevelIcon }}
                  </v-icon>
                </v-chip>
                <v-chip small>
                  <v-icon :color="supplyLevelColor">
                    mdi-paper-roll
                  </v-icon>
                </v-chip>
                <v-chip color="success" small>
                  <v-icon>
                    mdi-printer
                  </v-icon>
                </v-chip>
              </div>
              <div v-else class="ml-2">
                <v-chip color="error" small>
                  <v-icon>
                    mdi-printer-off
                  </v-icon>
                </v-chip>
              </div>
            </div>
            <div class="mt-4">
              <v-chip small v-if="config.operatorId" :class="breakpoint === 'xs' ? 'mt-2 mb-1' : ''">
                <v-icon small class="mr-1">mdi-account</v-icon>
                {{ operatorName }}
              </v-chip>
            </div>
            <div>
              <v-switch
                :class="screenLockOverlay"
                @change="focusBadge()"
                :disabled="!config.keyboardDisabled"
                color="secondary" v-model="isReadonly" :label="isReadonly ? 'Screen locked' : 'Screen unlocked'"
                style="width:180px" />
            </div>
            <div>
              <v-chip v-if="config.keyboardDisabled" small
                class="px-3 mr-1"><v-icon>mdi-keyboard-off-outline</v-icon></v-chip>
              <v-chip v-else small class="px-3 mr-1"><v-icon>mdi-keyboard-outline</v-icon></v-chip>
              <v-chip v-if="config.line != 'ignore' && config.line != null" small class="px-3 mr-1"
                :style="`background-color: ${getLineBgColor(config.line)}; color: ${getLineTextColor(config.line)}`">
                L{{ config.line }}
              </v-chip>
              <v-chip small class="px-2" v-if="!config.checkPedigreeDisabled" color="accent">
                <v-icon small>mdi-seal</v-icon>Pedigree
              </v-chip>
            </div>
            <div>
              <v-text-field  class="mr-4" style="padding-top:24px" v-model="searchValue" label="Search" clearable />
            </div>
          </v-col>
        </v-row>
        <v-row justify="center" class="mt-0" cols="12">
          <!--Insert the warninng label here with a condition that hides it-->
          <v-alert v-if="warningMsgDisplay" elevation="10" dismissible type="warning">
            {{ warningMsg }}
          </v-alert>
        </v-row>
        <v-card class="mt-5">
          <v-data-table :height="tableHeight" mobile-breakpoint="300" disable-sort dense group-by="operatorId"
            :headers="tblHeaders" :items="currentSamples" class="elevation-1 pt-1 cardbackground" :search="searchValue"
            :single-select="true" @focusin:row="clearSelectedItem" @mouseout:row="clearSelectedItem"
            @click:row="selectItem" item-key="date" :footer-props="{
              itemsPerPageOptions: breakpoint === 'xs' ? [5, 10, 25] : [10, 25, 50],
              'xxdisable-items-per-page': breakpoint === 'xs' ? true : false,
              itemsPerPageText: breakpoint === 'xs' ? 'rows' : 'rows per page'
            }">
            <template v-slot:[`item.grade`]="{ item }">
              <div class="d-flex justify-center align-center">
                <v-card class="ma-0 pa-1 caption"
                  :color="settings.eggGrades.find(e => e.code == item.grade).isSettable ? 'success' : 'warning'"
                  width="40px">
                  <span style="color:white">{{ item.grade ? item.grade.charAt(0) : '' }}</span>
                </v-card>
              </div>
            </template>
            <template v-slot:[`item.date`]="{ item }">
              <pre class="ma-0 pa-0 caption">{{ formatDate(item.date) }}</pre>
            </template>
            <template v-slot:[`item.reprint`]="{ item }">
              <v-btn fab small color="green" class="mx-1 my-1"
                @click="confirmReprint(item.line, currentHouse, item.badge)">
                <v-icon>mdi-printer</v-icon>
              </v-btn>
            </template>
            <template v-slot:[`item.delete`]="{ item }">
              <v-btn fab small color="secondary" class="mx-1 my-1" @click="confirmDeleteEggEntry(item)">
                <v-icon>mdi-delete-outline</v-icon>
              </v-btn>
            </template>
            <template v-slot:[`group.header`]="{ group, headers, toggle, isOpen }">
              <td nowrap style="padding-left:10px" :colspan="headers.length - 2">
                <v-btn class="mr-2" @click="toggle" small icon :ref="group" :data-open="isOpen">
                  <v-icon v-if="isOpen">mdi-chevron-up</v-icon>
                  <v-icon v-else>mdi-chevron-down</v-icon>
                </v-btn>
                <span>Operator: {{ getOperatorName(group) }}</span>
              </td>
              <td colspan="2" style="text-align: right">
                <div class="">count: {{ getEggCountForOperator(group) }}</div>
              </td>
            </template>
          </v-data-table>
        </v-card>
      </v-card-text>
    </v-card>

    <v-dialog v-model="showConfigDialog" persistent max-width="304">
      <v-card color="cardbackground">
        <v-card-title class="text-h5 mb-4"><v-icon class="mr-2">mdi-cog</v-icon>Collection Setup</v-card-title>
        <v-card-text class="mx-0 px-3">
          <v-select class="pa-0" v-model="dialogValues.config.operatorId" label="Operator" item-text="operatorName"
            item-value="operatorId" :items="operators" />
          <div class="d-flex flex-wrap">
            <div>
              <div class="text-subtitle-1">Line Check:</div>
              <v-select outlined dense class="mt-0 pt-0 mr-2"
                :style="`width:135px; --lineTextColor:${getLineTextColor(dialogValues.config.line)}`"
                :background-color="getLineBgColor(dialogValues.config.line)" hide-details
                v-model="dialogValues.config.line" ref="lineRef" :items="lines" hide-no-data>
                <template #item="{ item }">
                  <div v-if="item.value == 'ignore'" class="py-0 cardbackground"
                    style="text-align: center; width: 100%;">
                    {{ item.text }}
                  </div>
                  <div v-else class="py-0" :style='`text-align: center;
                      width: 100%;
                      background-color: ${getLineBgColor(item.value)};
                      color: ${getLineTextColor(item.value)};`'>
                    {{ item.text }}
                  </div>
                </template>
              </v-select>
            </div>
            <div class="mt-0">
              <div class="text-subtitle-1">Mobile Keyboard:</div>
              <div>
                <v-btn-toggle mandatory v-model="dialogValues.config.keyboardToggle">
                  <v-btn small height="40px" width="68px" class="py-4">
                    <v-icon>mdi-keyboard-outline</v-icon>
                  </v-btn>
                  <v-btn small height="40px" width="68px">
                    <v-icon>mdi-keyboard-off-outline</v-icon>
                  </v-btn>
                </v-btn-toggle>
              </div>
            </div>
          </div>
          <div class="mt-4 d-flex flex-wrap">
            <div class="mr-2">
              <div class="text-subtitle-1">Check Pedigree:</div>
              <v-btn-toggle mandatory v-model="dialogValues.config.checkPedigreeToggle">
                <v-btn small height="40px" width="68px" class="py-4">
                  <v-icon class="mr-1">mdi-check</v-icon>Yes
                </v-btn>
                <v-btn small height="40px" width="68px" class="py-4">
                  <v-icon class="mr-2">mdi-cancel</v-icon>No
                </v-btn>
              </v-btn-toggle>
            </div>
            <v-spacer />
            <div>
              <div class="text-subtitle-1">Confirm Badge:</div>
              <v-btn-toggle mandatory v-model="dialogValues.config.confirmBadgeToggle">
                <v-btn small height="40px" width="68px" class="py-4">
                  <v-icon class="mr-1">mdi-check</v-icon>Yes
                </v-btn>
                <v-btn small height="40px" width="68px" class="py-4">
                  <v-icon class="mr-2">mdi-cancel</v-icon>No
                </v-btn>
              </v-btn-toggle>
            </div>
          </div>
          <div class="mr-2">
            <div>
              <div class="text-subtitle-1">Sticker Warning:</div>
              <v-btn-toggle mandatory v-model="dialogValues.config.dontStickerWarningToggle">
                <v-btn small height="40px" width="68px" class="py-4">
                  <v-icon class="mr-1">mdi-check</v-icon>Yes
                </v-btn>
                <v-btn small height="40px" width="68px" class="py-4">
                  <v-icon class="mr-2">mdi-cancel</v-icon>No
                </v-btn>
              </v-btn-toggle>
            </div>
          </div>
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn large color="primary" class="white--text mb-2"
            :disabled="!dialogValues.config.line || !dialogValues.config.operatorId"
            @click="saveConfigValues(); showConfigDialog = false">
            Save
          </v-btn>
          <v-btn large color="secondary" class="mb-2" @click="showConfigDialog = false">
            Cancel
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialogValues.showAddDialog" persistent max-width="350">
      <v-card color="cardbackground">
        <v-card-title class="text-h5">Add Confirmation</v-card-title>
        <v-card-text>You have already collected an egg for this hen.<br />
          Badge: <b>{{ badge }}</b>
          <div class="mt-2 mr-4 text-h6 font-weight-black text-right">Add egg?</div>
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn color="primary" class="white--text" @click="addEgg(); dialogValues.showAddDialog = false;">
            Yes
          </v-btn>
          <v-btn color="secondary" @click="dialogValues.showAddDialog = false">Cancel</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialogValues.showReprintDialog" persistent max-width="250">
      <v-card color="cardbackground">
        <v-card-title class="text-h5">Confirm Reprint</v-card-title>
        <v-card-text>Reprint label for <br />
          Badge: <b>{{ labelToReprint.badge }}</b>?
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn color="primary" class="white--text"
            @click="printLabel(labelToReprint.line, labelToReprint.house, labelToReprint.badge); dialogValues.showReprintDialog = false">Yes</v-btn>
          <v-btn color="secondary" @click="dialogValues.showReprintDialog = false">Cancel</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialogValues.showDeleteDialog" persistent max-width="250">
      <v-card color="cardbackground">
        <v-card-title class="text-h5">Confirm Delete</v-card-title>
        <v-card-text>Is it okay to delete <br />
          Badge: <b>{{ entryToDelete.badge }}</b>,
          Grade: <b>{{ entryToDelete.grade }}</b>?
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn color="primary" class="white--text" @click="deleteEggEntry()">Yes</v-btn>
          <v-btn color="secondary" @click="dialogValues.showDeleteDialog = false">Cancel</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="showUnknownEggDialog" persistent max-width="250">
      <v-card color="cardbackground">
        <v-card-title class="text-h5">Unknown Badge</v-card-title>
        <v-card-text>
          <!-- v-radio-group hidden to make v-btn-toggle work correctly -->
          <v-radio-group v-show="false" v-model="unknownEggType">
            <v-radio label="Floor" :value="FLOOR_EGG"></v-radio>
            <v-radio label="Nest" :value="NEST_EGG"></v-radio>
          </v-radio-group>
          <span>Type:</span>
          <v-btn-toggle class="ml-2" v-model="unknownEggType">
            <v-btn small height="40px" width="68px" class="py-4" :value="FLOOR_EGG">
              Floor
            </v-btn>
            <v-btn small height="40px" width="68px" class="py-4" :value="NEST_EGG">
              Nest
            </v-btn>
          </v-btn-toggle>
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn color="primary" class="white--text" :disabled="!unknownEggType" @click="setUnknownBadge()">Yes</v-btn>
          <v-btn color="secondary" @click="showUnknownEggDialog = false">Cancel</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="showSummaryDialog" max-width="350">
      <v-card color="cardbackground">
        <v-card-title class="text-h5">
          <v-icon class="mr-2">mdi-file-document-outline</v-icon>
          Collection Summary
        </v-card-title>
        <v-card-text class="mt-2 px-4">
          <v-row justify="center">
            <v-col class="pa-1" style="flex: 0 0 150px; max-width: 150px;">
              <v-card outlined>
                <v-card-text class="text-center">
                  <div class="text-h5">{{ formatNumber(totalEggsCollected) }}</div>
                  <div>Total Eggs</div>
                </v-card-text>
              </v-card>
            </v-col>
            <v-col class="pa-1" style="flex: 0 0 150px; max-width: 150px;">
              <v-card outlined>
                <v-card-text class="text-center">
                  <div class="text-h5">{{ formatNumber(uniqueBadgesCollected) }}</div>
                  <div>Birds</div>
                </v-card-text>
              </v-card>
            </v-col>
            <v-col class="pa-1" style="flex: 0 0 150px; max-width: 150px;">
              <v-card outlined>
                <v-card-text class="text-center">
                  <div class="text-h5">{{ formatNumber(settableEggCount) }}</div>
                  <div>Settable Eggs</div>
                </v-card-text>
              </v-card>
            </v-col>
            <v-col class="pa-1" style="flex: 0 0 150px; max-width: 150px;">
              <v-card outlined>
                <v-card-text class="text-center">
                  <div class="text-h5">{{ formatNumber(unknownEggCount) }}</div>
                  <div>Floor/Nest Eggs</div>
                </v-card-text>
              </v-card>
            </v-col>
          </v-row>

          <v-row class="mt-4">
            <v-col cols="12">
              <div class="text-subtitle-1 font-weight-bold mb-2 text-center">Line Summary</div>
              <v-expansion-panels multiple flat>
                <v-expansion-panel v-for="row in summaryByLineTables" :key="`line-table-${row.line}`" class="mb-2">
                  <v-expansion-panel-header style="padding:8px;">
                    <table style="width: 100%; table-layout: fixed;">
                      <colgroup>
                        <col style="width: 80px;">
                        <col style="width: 80px;">
                        <col style="width: 90px;">
                      </colgroup>
                      <tr>
                        <td class="text-left">{{ row.line }}</td>
                        <td class="text-right">Total Eggs:</td>
                        <td class="pr-4 text-right">{{ formatNumber(row.total) }}</td>
                      </tr>
                    </table>
                  </v-expansion-panel-header>
                  <v-expansion-panel-content>
                    <v-simple-table dense>
                      <thead>
                        <tr>
                          <th>Grade</th>
                          <th class="text-right">Count</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-for="gradeRow in row.grades" :key="`line-${row.line}-grade-${gradeRow.gradeCode}`">
                          <td>{{ gradeRow.gradeDescription }}</td>
                          <td class="text-right">{{ formatNumber(gradeRow.count) }}</td>
                        </tr>
                      </tbody>
                    </v-simple-table>
                  </v-expansion-panel-content>
                </v-expansion-panel>
              </v-expansion-panels>
            </v-col>
          </v-row>

        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn color="primary" class="white--text" @click="showSummaryDialog = false">Close</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import OfflineStorage from '../utils/offlineStorage'
import { mapState } from 'vuex'
import eggPickerConstants from '../utils/eggPickerConstants'
import LabelManager from '../utils/LabelManager';
import printerIcons from '../utils/printerIcons';

export default {
  data() {
    return {
      FLOOR_EGG: eggPickerConstants.FLOOR_EGG,
      NEST_EGG: eggPickerConstants.NEST_EGG,
      badge: null,
      badgeObj: null,
      config: {
        checkPedigreeDisabled: false,
        confirmBadgeDisabled: false,
        keyboardDisabled: true,
        line: null,
        operatorId: null,
        dontStickerWarningDisabled: false
      },
      confirmBadge: null,
      currentSamples: [],
      dialogValues: {
        config: {
          checkPedigreeToggle: 0,
          confirmBadgeToggle: 0,
          keyboardToggle: 1,
          line: null,
          operatorId: null,
          dontStickerWarningToggle: 0
        },
        showAddDialog: false,
        showConfigDialog: false,
        showDeleteDialog: false,
        showReprintDialog: false,
        showUnknownEggDialog: false
      },
      eggGroups: null,
      entryToDelete: {},
      warningMsgDisplay: false,
      warningMsg: "",
      errorBadgeMsg: "",
      errorGradeMsg: "",
      errorConfirmBadgeMsg: "",
      grade: null,
      labelManager: new LabelManager(),
      labelToReprint: {},
      showSummaryDialog: false,
      searchValue: '',
      unknownEggType: null,
      windowSize: { x: 0, y: 0 },
      isReadonly: false
    }
  },

  mounted() {
    this.onResize();
    this.$refs.mainDiv.scrollIntoView();
    setTimeout(() => this.focusBadge(), 200);
  },

  async created() {
    try {

      this.eggGroups = await OfflineStorage.getItem('eggGroups');
      const eggCollectionGroup = this.eggGroups.find(x => x.groupName === this.groupName);

      this.config = {
        checkPedigreeDisabled: eggCollectionGroup.checkPedigreeDisabled ? true : false,
        confirmBadgeDisabled: eggCollectionGroup.confirmBadgeDisabled ? true : false,
        keyboardDisabled: eggCollectionGroup.keyboardDisabled == undefined ? true : eggCollectionGroup.keyboardDisabled,
        line: eggCollectionGroup.line ? eggCollectionGroup.line : null,
        operatorId: eggCollectionGroup.operatorId ? eggCollectionGroup.operatorId : null,
        dontStickerWarningDisabled: eggCollectionGroup.dontStickerWarningDisabled ? true : false,
      };

      this.dialogValues.config = {
        checkPedigreeToggle: this.config.checkPedigreeDisabled ? 1 : 0,
        confirmBadgeToggle: this.config.confirmBadgeDisabled ? 1 : 0,
        keyboardToggle: this.config.keyboardDisabled ? 1 : 0,
        operatorId: this.config.operatorId,
        line: this.config.line,
        dontStickerWarningToggle: this.config.dontStickerWarningToggle ? 1 : 0,
      }

      this.currentSamples = eggCollectionGroup.samples;

      if (this.dialogValues.config.operatorId == null || this.dialogValues.config.line == null) {
        this.showConfigDialog = true;
      } else {
        this.showConfigDialog = false;
      }
    } catch (error) {
      this.$root.showNoticeError(error.message);
    }
  },

  computed: {
    ...mapState(['settings', 'printer', 'printerConnected', 'printerData']),
    // addEggDisabled() {
    //   if (this.badge && this.grade && (this.config.confirmBadgeDisabled || this.confirmBadge)) {
    //     return false;
    //   } else {
    //     return true;
    //   }
    // },
    badges() {
      return this.settings.badges.filter(b => b.farmCode === this.currentFarm && b.houseCode === this.currentHouse);
    },
    breakpoint() {
      return this.$vuetify.breakpoint.name;
    },
    currentFarm() {
      let farm = this.groupName.split('_')[0];
      return farm;
    },
    currentHouse() {
      let house = this.groupName.split('_')[1];
      return house;
    },
    gradeDescs() {
      let eggGrades = this.settings.eggGrades;
      if (!this.badgeObj) return [];
      if (this.badgeObj.badgeCode == eggPickerConstants.FLOOR_EGG || this.badgeObj.badgeCode == eggPickerConstants.NEST_EGG) {
        return eggGrades.filter(e => e.isSuperSister).map(e => `${e.descr.toUpperCase()} (${e.code[0]})`);
      }
      if (this.badgeObj.isPedigree) {
        return eggGrades.filter(e => e.isPedigree).map(e => `${e.descr.toUpperCase()} (${e.code[0]})`);
      } else {
        return eggGrades.filter(e => e.isSuperSister).map(e => `${e.descr.toUpperCase()} (${e.code[0]})`);
      }
    },
    badgeGradeType() {
      if (this.badgeObj) { 
        if (this.badgeObj.isPedigree) {
          return '(Pedigree)';
        }
        if (this.config.checkPedigreeDisabled) {
          return '(Super Sister)';
        }
      }

      // Badge not found or badge is super sister but pedigree check is enabled
      return '';
    },
    isDialogOpen() {
      return this.showConfigDialog
        || this.dialogValues.showAddDialog
        || this.dialogValues.showReprintDialog
        || this.dialogValues.showDeleteDialog
        || this.dialogValues.showUnknownEggDialog;
    },
    groupName() {
      return this.$route.params.groupName;
    },
    lines() {
      let lineList = this.badges
        .filter(b => b.line !== null)
        .map(b => b.line);
      let uniqueLines = [...new Set(lineList)];

      let retList = uniqueLines.map(l => (
        {
          text: `  L${l}`,
          value: l,
        }
      ));
      retList = [{ text: 'Ignore', value: 'ignore' }].concat(retList);
      return retList;
    },
    operatorName() {
      if (this.config.operatorId == null) return '';
      let operatorName = "Unknown";
      let operator = this.settings.farmOperators.find(o => o.operatorId == this.config.operatorId);
      if (operator) operatorName = operator.operatorName;
      return operatorName;
    },
    operators() {
      //* Filter list to unique names for farm that are enabled.
      var uniqueOperators = this.settings.farmOperators
        .filter(f => f.farmCode = this.currentFarm && f.isEnabled == true)
        .filter((v, i, a) => a.findIndex(t => (t.operatorName === v.operatorName)) === i)
      return uniqueOperators;
    },
    screenLockOverlay() {
      if(this.isReadonly)
        return this.breakpoint === 'xs' ? 'mt-2 ml-2 overlay-switch': 'ml-2 overlay-switch'
      return this.breakpoint === 'xs' ? 'mt-2 ml-2': 'ml-2'
    },
    showConfigDialog: {
      get() {
        if (this.dialogValues.showConfigDialog === true) return true;
        else return false;
      },
      set(value) {
        if (value === true) {
          this.dialogValues.showConfigDialog = true;
        } else {
          this.dialogValues.showConfigDialog = false;
        }
      }
    },
    showUnknownEggDialog: {
      get() {
        return this.dialogValues.showUnknownEggDialog === true;
      },
      set(value) {
        if (value === true) {
          this.unknownEggType = null;
          this.dialogValues.showUnknownEggDialog = true;
        } else {
          this.dialogValues.showUnknownEggDialog = false;
        }
      }
    },
    tblHeaders() {
      const tableCols = [
        { text: 'Line', value: 'line', align: 'center', sortable: false },
        { text: 'Badge', value: 'badge', align: 'center' },
        { text: 'Wingband', value: 'wingband', align: 'center' },
        { text: 'Grade', value: 'grade', align: 'center' },
        { text: 'Date', value: 'date', align: 'center' },
        { text: 'Operator', value: 'operatorId' },
        { text: 'Delete', value: 'delete', align: 'center' }
      ];
      if (this.printerConnected) {
        tableCols.splice(-2, 0,
          { text: 'Reprint', value: 'reprint', align: 'center' }
        );
      }
      return tableCols;
    },
    tableHeight() {
      let tableSize = this.windowSize.y - 395;

      if (this.$vuetify.breakpoint.name == 'xs' || this.$vuetify.breakpoint.name === 'sm') {
        tableSize += 4; // v-app-bar shorter for xs and sm
      }
      if (tableSize < 200) tableSize = 200;
      return tableSize;
    },
    supplyLevelColor() {
      return printerIcons.getSupplyLevelColor(this.printerData.supplyRemainingPercentage);
    },
    batteryLevelColor() {
      return printerIcons.getBatteryLevelColor(this.printerData.batteryLevelPercentage);
    },
    batteryLevelIcon() {
      return printerIcons.getBatteryLevelIcon(this.printerData.batteryLevelPercentage, this.printerData.acCharging);
    },
    totalEggsCollected() {
      return this.currentSamples.length;
    },
    uniqueBadgesCollected() {
      return new Set(this.currentSamples.map(x => x.badge)).size;
    },
    unknownEggCount() {
      return this.currentSamples.filter(x => x.badge === this.FLOOR_EGG || x.badge === this.NEST_EGG).length;
    },
    settableEggCount() {
      const settableGrades = new Set((this.settings.eggGrades || []).filter(x => x.isSettable).map(x => x.code));
      return this.currentSamples.filter(x => settableGrades.has(x.grade)).length;
    },
    gradeDescriptionByCode() {
      return (this.settings.eggGrades || []).reduce((lookup, grade) => {
        lookup[grade.code] = grade.descr;
        return lookup;
      }, {});
    },
    summaryByLineTables() {
      const rows = new Map();

      this.currentSamples.forEach(sample => {
        const line = sample.line == null || sample.line === '' ? 'Unknown' : `L${sample.line}`;
        const gradeCode = sample.grade || 'Unknown';

        if (!rows.has(line)) {
          rows.set(line, { line, total: 0, grades: new Map() });
        }

        const row = rows.get(line);
        row.total += 1;
        if (!row.grades.has(gradeCode)) {
          row.grades.set(gradeCode, { gradeCode, gradeDescription: this.gradeDescriptionByCode[gradeCode] || gradeCode, count: 0 });
        }

        const gradeRow = row.grades.get(gradeCode);
        gradeRow.count += 1;
      });

      return Array.from(rows.values()).sort((a, b) => {
        if (a.line === 'Unknown') return 1;
        if (b.line === 'Unknown') return -1;
        return a.line.localeCompare(b.line, undefined, { numeric: true });
      }).map(row => ({
        line: row.line,
        total: row.total,
        grades: Array.from(row.grades.values()).sort((a, b) => {
          if (a.gradeCode === 'Unknown') return 1;
          if (b.gradeCode === 'Unknown') return -1;
          return a.gradeDescription.localeCompare(b.gradeDescription, undefined, { numeric: true });
        })
      }));
    },
  },

  methods: {
    async addEgg() {
      try {
        const now = new Date().toISOString();

        const sample = {
          badge: this.badge,
          operatorId: this.config.operatorId,
          grade: this.getGradeCode(this.grade),
          date: now,
          line: this.badgeObj.line,
          wingband: this.badgeObj.wingband,
        };

        this.currentSamples.unshift(sample); //add to beginning

        const eggCollectionGroup = this.eggGroups.find(x => x.groupName === this.groupName);
        eggCollectionGroup.samples = this.currentSamples;
        await OfflineStorage.setItem('eggGroups', this.eggGroups);

        this.showSettableNotice();

        this.resetInputFields();

        if (this.isSettable() && this.sticker()) {
          this.printLabel(this.badgeObj.line, this.badgeObj.houseCode, this.badge);
        }
      } catch (error) {
        this.$root.showNoticeError(error.message);
      }
    },
    async addUnknownEgg() {
      try {
        const wingband = this.badge;
        const now = new Date().toISOString();
        const sample = {
          badge: this.badge,
          operatorId: this.config.operatorId,
          grade: this.getGradeCode(this.grade),
          date: now,
          line: this.config.line == 'ignore' ? '' : this.config.line,
          wingband: wingband
        };
        this.currentSamples.unshift(sample); //add to beginning

        const eggCollectionGroup = this.eggGroups.find(x => x.groupName === this.groupName);
        eggCollectionGroup.samples = this.currentSamples;
        await OfflineStorage.setItem('eggGroups', this.eggGroups);

        this.showSettableNotice();

        this.resetInputFields();

        if (this.isSettable()) {

          this.printLabel(this.badgeObj.line, this.badgeObj.houseCode, this.badge);
        }
      } catch (error) {
        this.$root.showNoticeError(error.message);
      }
    },
    async generateQRCode(badge, line, house) {
      return this.labelManager.generateLabel(this.settings.label, badge, 'L' + line, house, 480, 620);
    },
    async printLabel(toptext1, toptext2, bottomtext) {
      if (this.printerConnected) {
        const label = await this.generateQRCode(bottomtext, toptext1, toptext2);
        this.printer.print(label);
      }
    },
    badgeChanged() {
      this.warningMsg = '';
      this.warningMsgDisplay = false;
      if (this.badge == null) {
        this.badgeObj = undefined;
        return;
      }

      // Handle special badge value for floor and nest eggs
      if (this.badge == this.FLOOR_EGG || this.badge == this.NEST_EGG) {
        this.badgeObj = {
          badgeCode: this.badge, 
          wingband: this.badge,
          farmCode: this.currentFarm,
          houseCode: this.currentHouse,
          line: null,
        }
        return;
      }

      this.badgeObj = this.badges.find(b => b.badgeCode === this.badge);
      if (this.badgeObj == null || this.config.dontStickerWarningDisabled == true) {
        return;
      }

      if (this.badgeObj.fuzzyMiniGenerationNum <= -8) {
        this.warningMsg = "OLD SOURCE - DO NOT STICKER";
        this.makeWarningSound();
      }
      else if (this.badgeObj.dispositionValueCode == "Extra Pedigree") {
        this.warningMsg = "EXTRA PEDIGREE - DO NOT STICKER";
        this.makeWarningSound();
      }

      this.warningMsgDisplay = this.warningMsg != '';
    },
    badgeBinarySearch(arr, badgeCode) {
      var min = 0;
      var max = arr.length - 1;
      var guess;
      while (min <= max) {
        guess = Math.floor((min + max) / 2);
        if (arr[guess].badgeCode === badgeCode) {
          return arr[guess];
        } else {
          if (arr[guess].badgeCode < badgeCode) {
            min = guess + 1;
          } else {
            max = guess - 1;
          }
        }
      }
      return undefined;
    },
    getGradeCode(gradeDescr) {
      var gradeObj = this.settings.eggGrades.find(g => gradeDescr.indexOf(g.descr.toUpperCase()) == 0);
      return gradeObj.code;
    },
    getGradeDescr(gradeDescr) {
      var gradeObj = this.settings.eggGrades.find(g => gradeDescr.indexOf(g.descr.toUpperCase()) == 0);
      return gradeObj.descr;
    },
    clearSearchResults() {
      this.$nextTick(() => {
        if (this.searchValue) {
          this.searchValue = '';
        }
      });
    },
    selectItem(event, row) {
      row.select();
    },
    clearSelectedItem(data, row) {
      if (row.isSelected && this.isDialogOpen == false) {
        row.select(false);
      }
    },
    confirmReprint(line, house, badge) {
      this.labelToReprint = {
        line: line,
        house: house,
        badge: badge
      };
      this.dialogValues.showReprintDialog = true;
    },
    confirmDeleteEggEntry(item) {
      this.entryToDelete = {
        badge: item.badge,
        wingband: item.wingband,
        grade: item.grade,
        date: item.date
      }

      this.dialogValues.showDeleteDialog = true;
    },
    async deleteEggEntry() {
      try {
        const index = this.currentSamples.findIndex(x =>
          x.badge === this.entryToDelete.badge &&
          x.wingband === this.entryToDelete.wingband &&
          x.grade === this.entryToDelete.grade &&
          x.date === this.entryToDelete.date
        );
        this.currentSamples.splice(index, 1);

        const eggCollectionGroup = this.eggGroups.find(x => x.groupName === this.groupName);
        eggCollectionGroup.samples = this.currentSamples;
        await OfflineStorage.setItem('eggGroups', this.eggGroups);

        this.$root.showNoticeSuccess(`Badge: ${this.entryToDelete.badge} Grade: ${this.entryToDelete.grade} deleted successfully`);

        this.wingbandToDelete = null;
        this.dialogValues.showDeleteDialog = false;
      } catch (error) {
        this.$root.showNoticeError(error.message);
      }
    },
    focusBadge() {
      if (this.$refs.badgeRef == null) return;
      this.clearSearchResults();
      //document.activeElement.blur();
      this.$refs.badgeRef.focus();
    },
    focusConfirmBadge() {
      if (this.$refs.confirmBadgeRef == null) return;
      this.clearSearchResults();
      //document.activeElement.blur();
      this.$refs.confirmBadgeRef.focus();
    },
    focusGrade() {
      if (this.$refs.gradeRef == null) return;
      this.clearSearchResults();
      //document.activeElement.blur();
      this.$refs.gradeRef.focus();
    },
    formatDate(dt) {
      let localDt = new Date(dt).toLocaleString();
      localDt = localDt.replace(',', '').replace(' ', '\n');
      return localDt;
    },
    formatNumber(value) {
      return new Intl.NumberFormat().format(Number(value) || 0);
    },
    getEggCountForOperator(operatorId) {
      return this.currentSamples.filter(e => e.operatorId === operatorId).length;
    },
    getLineBgColor(lineCode) {
      let line = this.settings.farmLines.find(fl => fl.lineCode == lineCode);
      if (line) {
        return `#${line.backgroundColor}`;
      } else {
        return '';
      }
    },
    getLineTextColor(lineCode) {
      let line = this.settings.farmLines.find(fl => fl.lineCode == lineCode);
      if (line) {
        return `#${line.textColor}`;
      } else {
        return '';
      }
    },
    getOperatorName(id) {
      var operatorName = 'Unknown';
      if (id) {
        const operator = this.settings.farmOperators.find(o => o.operatorId === id);
        if (operator) operatorName = operator.operatorName;
      }
      return operatorName;
    },
    validateBadge(v) {
      //* Check if unknown egg
      if (v == this.FLOOR_EGG || v == this.NEST_EGG) {
        if (this.config.checkPedigreeDisabled) {
          return null;
        } else {
          return `${v} is not valid for Pedigree.`;
        }
      }

      //* Check if badge exists and badge has wingband
      if (!this.badgeObj) return `Badge ${v} not found.`;
      if (!this.badgeObj.wingband) return `No wingband exists for Badge ${v}.`;

      //* Check if pedigree if Pedigree check is enabled)
      if (!this.config.checkPedigreeDisabled && !this.badgeObj.isPedigree) {
        return `${this.badgeObj.wingband} (Badge ${v}) is not Pedigree.`;
      }

      //* Check line if line check enabled
      if (this.config.line === 'ignore') return null;
      if (!this.badgeObj.line) return `No line exists for Badge ${v}.`;
      if (this.badgeObj.line == this.config.line) return null;
      return `Badge ${v} line (${this.badgeObj.line}) does not match line check (${this.config.line}).`;
    },
    isGradeValidRule(v) {
      if (this.gradeDescs.find(g => g === v)) {
        return null;
      } else {
        return `Grade ${v} is invalid.`;
      }
    },
    makeErrorSound() {
      if (this.settings.isErrorSoundEnabled) {
        const audio = new Audio('sound/error-beep.mp3');
        audio.play();
      }
    },
    makeSuccessSound() {
      if (this.settings.isSuccessSoundEnabled) {
        const audio = new Audio('sound/success-chime.mp3');
        audio.play();
      }
    },
    makeWarningSound() {
      if (this.settings.isWarningSoundEnabled) {
        const audio = new Audio('sound/warning-beep.mp3');
        audio.play();
      }
    },
    makeBeepSound() {
      if (this.settings.isSuccessSoundEnabled) {
        const audio = new Audio('sound/success-beep.mp3');
        audio.play();
      }
    },
    navigateBack() {
      this.$router.replace({ name: 'Egg Collection Groups' });
    },
    onbadgeFocus(e) {
      e.target.select();
      this.clearSearchResults();
    },
    onGradeFocus(e) {
      e.target.select();
      this.clearSearchResults();
    },
    onResize() {
      this.windowSize = { x: window.innerWidth, y: window.innerHeight }
    },
    resetErrorMessages() {
      this.errorBadgeMsg = "";
      this.errorGradeMsg = "";
      this.errorConfirmBadgeMsg = "";
    },
    resetInputFields() {
      setTimeout(() => { // needed for timing issue after closing error notice.
        this.searchValue = '';
        this.badge = null;
        this.grade = null;
        this.confirmBadge = null;
        this.resetErrorMessages();
        this.$refs.badgeRef.focus();
      }, 100);
    },
    async saveConfigValues() {
      this.config.line = this.dialogValues.config.line;
      this.config.operatorId = this.dialogValues.config.operatorId;
      this.config.checkPedigreeDisabled = !!this.dialogValues.config.checkPedigreeToggle;
      this.config.confirmBadgeDisabled = !!this.dialogValues.config.confirmBadgeToggle;
      this.config.keyboardDisabled = !!this.dialogValues.config.keyboardToggle;
      this.config.dontStickerWarningDisabled = !!this.dialogValues.config.dontStickerWarningToggle;

      const eggCollectionGroup = this.eggGroups.find(x => x.groupName === this.groupName);
      eggCollectionGroup.line = this.config.line;
      eggCollectionGroup.operatorId = this.config.operatorId;
      eggCollectionGroup.checkPedigreeDisabled = this.config.checkPedigreeDisabled;
      eggCollectionGroup.confirmBadgeDisabled = this.config.confirmBadgeDisabled;
      eggCollectionGroup.keyboardDisabled = this.config.keyboardDisabled;
      eggCollectionGroup.dontStickerWarningDisabled = this.config.dontStickerWarningDisabled;

      await OfflineStorage.setItem('eggGroups', this.eggGroups);

      if (this.badge || this.grade || this.confirmBadge) {
        this.validateInputFields();
      }
    },
    async setUnknownBadge() {
      this.badge = this.unknownEggType;
      this.badgeObj = {
        badgeCode: this.unknownEggType, 
        wingband: this.unknownEggType,
        farmCode: this.currentFarm,
        houseCode: this.currentHouse,
        line: null,
      }
      
      if (!this.config.confirmBadgeDisabled)
        this.confirmBadge = this.unknownEggType;

      this.showUnknownEggDialog = false;
      setTimeout(() => this.$refs.gradeRef.focus(), 200);
    },
    showSummary() {
      this.showSummaryDialog = true;
    },
    showGradeMenu(val) {
      this.$refs.gradeRef.isMenuActive = val;
      this.clearSearchResults();
    },
    showSettableNotice() {
      if (this.isSettable()) {
        this.$root.showNoticeSuccess(`Settable Egg added successfully.`);
        this.makeSuccessSound();
      } else {
        this.$root.showNoticeWarning(`Non-Settable Egg added successfully.`);
        this.makeBeepSound();
      }
    },
    isSettable() {
      let eggGrades = this.settings.eggGrades;
      let gradedescr = this.getGradeDescr(this.grade);
      let isSettable = eggGrades.find(e => e.descr === gradedescr)?.isSettable;
      return isSettable;
    },
    sticker() {
      if (this.config.dontStickerWarningDisabled == false) {
        if (this.badgeObj.fuzzyMiniGenerationNum <= -8 || this.badgeObj.dispositionValueCode == "Extra Pedigree") {
          return false;
        }
      }
      return true;
    },
    toUpperCase(value) {
      return (value || "").toUpperCase();
    },
    validateInputFields() {
      this.errorBadgeMsg = "";
      this.errorGradeMsg = "";
      this.errorConfirmBadgeMsg = "";
      let msg = null;

      //* Validate Badge (entered, found, line valid, etc.)
      if (!this.badge) {
        this.$refs.badgeRef.focus();
        this.errorBadgeMsg = "Required";
        return;
      }
      msg = this.validateBadge(this.badge);
      if (msg !== null) {
        this.makeErrorSound();
        this.errorBadgeMsg = msg;
        this.focusBadge();
        return;
      }

      //* Validate Grade is proper grade for pedigree or supersister.
      if (!this.grade) {
        this.$refs.gradeRef.focus();
        this.errorGradeMsg = "Required";
        return;
      }
      msg = this.isGradeValidRule(this.grade);
      if (msg !== null) {
        this.makeErrorSound();
        this.errorGradeMsg = msg;
        this.focusGrade();
        return;
      }

      //* Validate Confirm Badge (if enabled)
      if (!this.config.confirmBadgeDisabled) {
        if (!this.confirmBadge) {
          this.$refs.confirmBadgeRef.focus();
          this.errorConfirmBadgeMsg = "Required";
          return;
        }
        if (this.badge !== this.confirmBadge) {
          this.makeErrorSound();
          this.errorConfirmBadgeMsg = "Badge mismatch.";
          this.focusConfirmBadge();
          return;
        }
      }
    },
    valueEntered() {
      this.validateInputFields();
      if (this.errorBadgeMsg || this.errorGradeMsg || this.errorConfirmBadgeMsg) {
        return; // don't add egg if errors.
      }
      // Add Egg to list if FLOOR or NEST.
      if (this.badge == this.FLOOR_EGG) {
        this.unknownEggType = this.FLOOR_EGG;
        this.addUnknownEgg();
        return;
      }
      if (this.badge == this.NEST_EGG) {
        this.unknownEggType = this.NEST_EGG;
        this.addUnknownEgg();
        return;
      }

      //* Add Egg to list (confirm if egg already in list).
      const eggExists = this.currentSamples.find(e => e.badge === this.badge);
      if (eggExists) {
        this.makeErrorSound();
        this.dialogValues.showAddDialog = true;
      } else {
        this.addEgg();
      }
    }
  }
}
</script>
<style>
.text-center {
  /* shrink table padding */
  padding: 0px !important;
  font-size: 12px !important;
}

.v-select__selection {
  color: var(--lineTextColor) !important
}

.v-data-footer {
  flex-wrap: nowrap;
  padding: 0 0 0 0
}

.badge-floor-egg-style .v-messages__message {
  color: orange
}

.overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background: rgba(255, 255, 255, 0.5);
  z-index: 9999;
}

.hamburger-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 72px;
  height: 72px;
  z-index: 10001;
}

.overlay-switch {
  position: relative;
  z-index: 10000;
  height: 44px;
  width: 44px;
}
</style>